import React from "react";
import { Icon } from "@chakra-ui/icons";

import { ReactComponent as Edit2FillIcon } from "../../assets/edit-2-fill.svg";

export const Edit2Fill = (props) => {
  return <Icon as={Edit2FillIcon} {...props} />;
};
